<div class="container">
  <div class="row justify-content-center">
    <div *ngIf="articles.length === 0">{{ "no_articles" | translate }}</div>
    <div *ngFor="let article of articles" class="col-md-11 mb-3">
      <div class="card">
        <div class="card-body d-flex justify-content-between">
          <!-- LEFT SIDE -->
          <div class="flex-grow-1 d-flex flex-column">
            <h5 class="card-title">{{ article.title[this.language] }}</h5>
            <p
              *ngIf="article.description"
              class="card-text"
              [innerHtml]="
                getShortDescription(article.description[this.language], 400)
                  | urlDetector
              "
            ></p>

            <button
              *ngIf="!hideReadMore"
              class="btn btn-primary mt-2 align-self-start"
              (click)="openArticle(article)"
            >
              {{ "read_more" | translate }}
            </button>
          </div>

          <!-- RIGHT SIDE (image OR video OR PDFs) -->
          <div class="ms-3 d-flex align-items-center">
            <!-- IMAGE -->
            <div class="article-image-container" *ngIf="article.images?.length">
              <img
                [src]="article.images[0] || ''"
                alt="{{ article.title }}"
                class="article-image"
              />
            </div>
            <!-- VIDEO -->
            <app-youtube-player
              *ngIf="!article.images?.length && article.videos?.length"
              [videoID]="article.videos[0]"
            ></app-youtube-player>

            <!-- PDFS -->
            <div
              *ngIf="
                !article.images?.length &&
                !article.videos?.length &&
                article.pdfs?.length
              "
              class="d-flex flex-row flex-wrap align-items-center gap-3"
            >
              <div
                *ngFor="let pdf of article.pdfs"
                class="d-flex align-items-center"
              >
                <!-- PDF icon -->
                <mat-icon color="warn" class="me-1">picture_as_pdf</mat-icon>

                <!-- File name -->
                <span class="me-2">
                  {{ pdf.originName }}
                </span>

                <!-- Download -->
                <button
                  mat-icon-button
                  color="primary"
                  (click)="downloadPdf(pdf)"
                >
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <nav aria-label="Page navigation example">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="changePage(currentPage - 1)">{{
          "previous" | translate
        }}</a>
      </li>
      <li
        class="page-item"
        *ngFor="let page of totalPagesArray"
        [class.active]="currentPage === page"
      >
        <a class="page-link" (click)="changePage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="changePage(currentPage + 1)">{{
          "next" | translate
        }}</a>
      </li>
    </ul>
  </nav>
</div>
